var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActivationConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8687 20.8687C19.8844 21.8531 18.2812 21.8531 17.2969 20.8687L14.9062 18.4781C14.1469 17.7188 13.95 16.5656 14.4281 15.6094L16.5094 17.6906C16.8469 18 17.3531 18 17.6906 17.6625 18 17.3531 18.0281 16.8188 17.7188 16.4812L15.6375 14.4C16.5938 13.95 17.7469 14.1469 18.5063 14.9062L20.8969 17.2969C21.8531 18.2812 21.8531 19.8562 20.8687 20.8687ZM8.52187 12.0938 6.13125 9.70312C5.14687 8.71875 5.14687 7.11562 6.13125 6.13125 7.11562 5.14687 8.71875 5.14687 9.70312 6.13125L12.0938 8.52187C12.8531 9.28125 13.05 10.4344 12.6 11.3906L10.9125 9.70312C10.575 9.39375 10.0687 9.39375 9.73125 9.73125 9.42188 10.0406 9.39375 10.575 9.70312 10.9125L11.3906 12.6C10.4344 13.05 9.28125 12.8531 8.52187 12.0938ZM22.05 16.0875 19.6594 13.6969C18.2531 12.2625 16.0031 12.0375 14.3438 13.1625L13.8375 12.6562C14.9344 10.9969 14.7094 8.775 13.3031 7.34063L10.9125 4.95C9.25313 3.43125 6.66563 3.4875 5.0625 5.0625 3.45938 6.66563 3.40313 9.225 4.95 10.9125L7.34063 13.3031C8.74687 14.7375 10.9969 14.9625 12.6562 13.8375L13.1625 14.3438C12.0656 16.0031 12.2906 18.225 13.6969 19.6594L16.0875 22.05C17.7469 23.5969 20.3344 23.5406 21.9375 21.9375 23.5406 20.3344 23.5969 17.7469 22.05 16.0875L22.05 16.0875Z",
    fill: "#FFFFFF",
    transform: "matrix(1.03704 0 0 1 108 306)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivationConnections);
export default __webpack_public_path__ + "static/media/icon-activation-connections.23d22e016d2850bf6868ee3bedfe8d4e.svg";
export { ForwardRef as ReactComponent };